import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { Layout as BaseLayout } from 'components/Layout/Layout'
import { useAuth } from 'utils/auth'
import AndroidHandler from 'utils/androidHandler'
import { refreshSessionApp, refreshSessionWeb } from 'utils/api'
import { APP_LOGIN_STORAGE_KEY } from 'configs/auth'
import { isToggleEnabled } from 'configs/toggle-feature'
import { Spinner } from 'components/Spinner'

import type { GetServerSideProps } from 'next'

export const getServerSideProps: GetServerSideProps = async () => {
  const isSeamlessLoginEnabled = await isToggleEnabled(
    'lms-lti-seamless-login-enabled'
  )

  if (!isSeamlessLoginEnabled) {
    return {
      redirect: {
        permanent: false,
        destination: '/',
      },
    }
  }
  return {
    props: {},
  }
}

const validateSession = async () => {
  const androidHandler = AndroidHandler()
  const refreshSession = androidHandler.enabled
    ? refreshSessionApp
    : refreshSessionWeb
  return await refreshSession(APP_LOGIN_STORAGE_KEY)
}

export default function SSOPage() {
  const router = useRouter()
  const { session } = useAuth()

  useEffect(() => {
    if (typeof window === 'undefined') return
    const params = new URLSearchParams(window.location.search)
    const target = params.get('target')
    const redirectTo = params.get('redirectTo') || '/'
    const guruToken = session?.guruToken
    if (!target || !guruToken) return

    if (!guruToken) {
      router.replace('/login')
      return
    }

    const passSSOToken = async () => {
      try {
        await validateSession()
        const response = await fetch('/api/sso-sign', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: session, target, redirectTo }),
        })
        const data = await response.json()
        if (!data.sso) {
          throw new Error('SSO sign error No Data')
        }
        /** Redirect using replace to the SSO Token validator in the target web app */
        window.location.replace(`${target}?sso=${data.sso}`)
      } catch (err: unknown) {
        console.error('Error SSO sign', err)
        router.push('/')
      }
    }

    passSSOToken()
  }, [router, session])

  return (
    <div className="flex justify-center items-center flex-col h-screen space-y-2">
      <Spinner className="!m-0" />
      <p>Sedang menyiapkan...</p>
    </div>
  )
}

SSOPage.Layout = BaseLayout

SSOPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: false,
}
